import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const LogoLink = ({ href, src, alt }) => {
  return (
    <Link href={href}>
      <img src={src} alt={alt} />
    </Link>
  );
};

const BrandsLogos = ({ blok }) => {
  return (
    <div className="brandslogos-wrap wrap" {...storyblokEditable(blok)}>
      <div className="brandslogos-rowcontent">
        {blok.logo1.filename && (
          <LogoLink
            href={blok.link1}
            src={blok.logo1.filename}
            alt={blok.logo1.alt}
          />
        )}
        {blok.logo2.filename && (
          <LogoLink
            href={blok.link2}
            src={blok.logo2.filename}
            alt={blok.logo2.alt}
          />
        )}

        {blok.logo3.filename && (
          <LogoLink
            href={blok.link3}
            src={blok.logo3.filename}
            alt={blok.logo3.alt}
          />
        )}

        {blok.logo4.filename && (
          <LogoLink
            href={blok.link4}
            src={blok.logo4.filename}
            alt={blok.logo4.alt}
          />
        )}

        {blok.logo5.filename && (
          <LogoLink
            href={blok.link5}
            src={blok.logo5.filename}
            alt={blok.logo5.alt}
          />
        )}

        {blok.logo6.filename && (
          <LogoLink
            href={blok.link6}
            src={blok.logo6.filename}
            alt={blok.logo6.alt}
          />
        )}

        {blok.logo7.filename && (
          <LogoLink
            href={blok.link7}
            src={blok.logo7.filename}
            alt={blok.logo7.alt}
          />
        )}

        {blok.logo8.filename && (
          <LogoLink
            href={blok.link8}
            src={blok.logo8.filename}
            alt={blok.logo8.alt}
          />
        )}
      </div>
    </div>
  );
};

export default BrandsLogos;
